import ActivityAction from './ActivityAction';

export default ActivityAction;
